module.exports = __webpack_public_path__ + "img/arrow_up.a32ced3f.png";